module.exports = __webpack_public_path__ + "img/by.by4c57e6c.svg";